import { createFileRoute, notFound } from "@tanstack/react-router";

import { CancellationClient } from "@/booking/cancel/CancellationClient";
import { getBookingByCancellationIdFn } from "@/server-fns/booking/serverFns";

export const Route = createFileRoute("/booking/cancel/$token")({
    loader: async ({ params }) => {
        const booking = await getBookingByCancellationIdFn({
            data: { token: params.token },
        });
        if (!booking) {
            throw notFound();
        }
        return { booking };
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { token } = Route.useParams();
    const { booking } = Route.useLoaderData();

    return <CancellationClient booking={booking} token={token} />;
}
